import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  APPLICATION_MODE_NEW
} from "../../app/constants";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { NOT_LICENCED, LICENCED_INDIVIDUAL } from "../../redux/slice/primaryAgencyApplicationSlice";
import { Button } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";

const MORTGAGE_APPLICATION_PROPERTY = "licenceAnotherProvince";

export const exemptProvinces = [
  "British Columbia",
  "Alberta",
  "Saskatchewan",
  "Manitoba",
  "Ontario",
  "Quebec",
  "New Brunswick"
];

const exemptProvincesBroker = [
  "Mortgage associate, Alberta",
  "Submortgage broker, British Columbia",
  "Mortgage salesperson, Manitoba",
  "Mortgage associate, New Brunswick",
  "Mortgage agent (level 1 or level 2), Ontario",
  "Mortgage broker, Quebec",
  "Mortgage associate, Saskatchewan"
];

export const HasAssociateMortgageBrokerLicenceInProvinces = (props) => {
  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType =
    agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION;
  const previouslyLicencedStatus =
    agentApplication.businessLicenceData?.previouslyLicencedStatus ?? LICENCED_INDIVIDUAL;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;

  const dispatch = useDispatch();

  const handleNext = (licenceAnotherProvince) => {
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: licenceAnotherProvince
      })
    );

    const noOption = !isPrincipalBroker
      ? ROUTE_PATH.MRA_ASSOCIATE_HAS_EDUCATION
      : ROUTE_PATH.MRA_PRINCIPAL_BROKER_INELIGIBLE;

    const noPath =
      previouslyLicencedStatus === NOT_LICENCED ? noOption : ROUTE_PATH.MRA_LICENCE_NUMBER;

    const nextPath = licenceAnotherProvince ? ROUTE_PATH.MRA_ASSOCIATE_BROKER_LICENCE_INFO : noPath;
    dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
  };

  const title = isPrincipalBroker
    ? "Do you have at least 1 current Mortgage Broker Licence from this list?"
    : previouslyLicencedStatus === NOT_LICENCED
      ? "Does the applicant have at least 1 current Associate Mortgage Broker Licence (or equivalent) from this list?"
      : "Does the applicant have at least 1 current Mortgage Broker Licence from this list?";

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar
        {...props}
        applicationType={applicationTypeFromLicenceSubType(licencingSubType)}
        applicationMode={APPLICATION_MODE_NEW}
      />
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <h1>{title}</h1>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-xs-12 col-lg-10">
          <h5>
            *Applicant must have a Mortgage Broker licence in another province, not an Associate Mortgage Broker licence.
          </h5>
        </div>
      </div> */}
      {/* Information Paragraphs */}
      <div className="row">
        <div className="col-lg-8">
          <ul style={{ lineHeight: "2.5em" }}>
            {exemptProvincesBroker.sort().map((p) => (
              <li>{p}</li>
            ))}
          </ul>
        </div>
      </div>
      {isPrincipalBroker && (
        <div className="row">
          <div className="col-xs-12 col-lg-10">
            {`If yes, you are exempt from completing the Nova Scotia Mortgage Broker Education Program.`}
          </div>
        </div>
      )}
      {!isPrincipalBroker && previouslyLicencedStatus !== NOT_LICENCED && (
        <div className="row">
          <div className="col-xs-12 col-lg-10">
            {`If yes, the applicant is exempt from completing the Nova Scotia Mortgage Broker Education Program.`}
          </div>
        </div>
      )}
      {!isPrincipalBroker && previouslyLicencedStatus === NOT_LICENCED && (
        <>
          <div className="row bottomMarginNormal">
            <div className="col-xs-12 col-lg-10">
              If yes, the applicant is exempt from completing the Nova Scotia Associate Mortgage Broker
              Education Program.
            </div>
          </div>
          {/* 
          <div className="row bottomMarginNormal">
            <div className="col-xs-12 col-lg-10">
              If yes, you'll continue the application to apply for a <b>Mortgage Broker Licence.</b>
              <br />
              The applicant is exempt from completing the Nova Scotia Mortgage Broker Education Program.
            </div>
          </div>
          <div className="row bottomMarginNormal">
            <div className="col-xs-12 col-lg-10">
              If you want to apply for an <b>Associate Mortgage Broker Licence</b> (even if you have a licence in another province), select "No"
            </div>
          </div>
         */}
        </>
      )}
      {/*
        if principal broker -> one thing
        if not, then  -> 
            if (previouslyLicencedStatus === NOT_LICENCED) -> 
       */}
      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={() => {
              handleNext(true);
            }}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={() => {
              handleNext(false);
            }}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
